import React, { useState } from 'react';
import WrapperComponent from './commonComponents/WrapperComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const SimpleFormComponent = () => {
    const [callPhoneRows, setCallPhoneRows] = useState([]);
    const [copyOfferRows, setCopyOfferRows] = useState([]);
    const [visitWebsiteRows, setVisitWebsiteRows] = useState([]);
    const [customQuickReplyRows, setCustomQuickReplyRows] = useState([]);
    const [marketingOptOutRows, setMarketingOptOutRows] = useState([]);

    const handleAddMarketingOptOutRow = () => {
        if (marketingOptOutRows.length >= 1) {
            alert('You can only add one Marketing opt-out buttons.');
            return;
        }
        setMarketingOptOutRows([
            ...marketingOptOutRows,
            { id: Date.now(), consentChecked: true },
        ]);
        document.querySelector('input[name="quickReplyOption"][value="Marketing opt-out"]').checked = false;
    };

    const handleRemoveMarketingOptOutRow = (id) => {
        setMarketingOptOutRows(marketingOptOutRows.filter((row) => row.id !== id));
        document.querySelector('input[name="quickReplyOption"][value="Marketing opt-out"]').checked = false;
    };

    const handleConsentChange = (id, checked) => {
        const updatedRows = marketingOptOutRows.map((row) =>
            row.id === id ? { ...row, consentChecked: checked } : row
        );
        setMarketingOptOutRows(updatedRows);
    };

    const handleAddCustomQuickReplyRow = () => {
        if (customQuickReplyRows.length >= 2) {
            alert('You can only add two Custom Quick Reply buttons.');
            return;
        }
        setCustomQuickReplyRows([
            ...customQuickReplyRows,
            { id: Date.now(), buttonText: '' },
        ]);
        document.querySelector('input[name="quickReplyOption"][value="Custom"]').checked = false;
    };

    const handleRemoveCustomQuickReplyRow = (id) => {
        setCustomQuickReplyRows(customQuickReplyRows.filter((row) => row.id !== id));
        document.querySelector('input[name="quickReplyOption"][value="Custom"]').checked = false;
    };

    const handleCustomQuickReplyChange = (id, value) => {
        const updatedRows = customQuickReplyRows.map((row) =>
            row.id === id ? { ...row, buttonText: value } : row
        );
        setCustomQuickReplyRows(updatedRows);
    };
    
    const handleAddVisitWebsiteRow = () => {
        if (visitWebsiteRows.length >= 2) {
            alert('You can only add two Visit Website buttons.');
            return;
        }
        setVisitWebsiteRows([
            ...visitWebsiteRows,
            { id: Date.now(), buttonText: '', dropdownValue: 'Static', url: '' },
        ]);
        document.querySelector('input[name="callToActionOption"][value="Visit Website"]').checked = false;
    };

    const handleRemoveVisitWebsiteRow = (id) => {
        setVisitWebsiteRows(visitWebsiteRows.filter((row) => row.id !== id));
        document.querySelector('input[name="callToActionOption"][value="Visit Website"]').checked = false;
    };

    const handleVisitWebsiteChange = (id, field, value) => {
        const updatedRows = visitWebsiteRows.map((row) =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setVisitWebsiteRows(updatedRows);
    };

    const isValidDomain = (url, dropdownValue) => {
        const staticRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/; // Static domain validation
        const dynamicRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*(\/\{\{\d+\}\})?$/; // Dynamic domain validation
        return dropdownValue === 'Static' ? staticRegex.test(url) : dynamicRegex.test(url);
    };

    const handleAddCallPhoneRow = () => {
        if (callPhoneRows.length >= 1) {
            alert('You can only add one Call Phone Number button.');
            return;
        }
        setCallPhoneRows([...callPhoneRows, { id: Date.now(), mobileNumber: '' }]);
        document.querySelector('input[name="callToActionOption"][value="Call Phone Number"]').checked = false;
    };

    const handleRemoveCallPhoneRow = (id) => {
        setCallPhoneRows(callPhoneRows.filter((row) => row.id !== id));
        document.querySelector('input[name="callToActionOption"][value="Call Phone Number"]').checked = false;
    };

    const handleMobileNumberChange = (id, value) => {
        const updatedRows = callPhoneRows.map((row) =>
            row.id === id ? { ...row, mobileNumber: value } : row
        );
        setCallPhoneRows(updatedRows);
    };

    const handleAddCopyOfferRow = () => {
        if (copyOfferRows.length >= 1) {
            alert('You can only add one Copy Offer Code button.');
            return;
        }
        setCopyOfferRows([...copyOfferRows, { id: Date.now(), offerCode: '' }]);
        document.querySelector('input[name="callToActionOption"][value="Copy Offer Code"]').checked = false;
    };

    const handleRemoveCopyOfferRow = (id) => {
        setCopyOfferRows(copyOfferRows.filter((row) => row.id !== id));
        document.querySelector('input[name="callToActionOption"][value="Copy Offer Code"]').checked = false;
    };

    const handleOfferCodeChange = (id, value) => {
        const updatedRows = copyOfferRows.map((row) =>
            row.id === id ? { ...row, offerCode: value } : row
        );
        setCopyOfferRows(updatedRows);
    };

    const isValidOfferCode = (code) => {
        const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{3,15}$/; // At least 1 letter, 1 number, no spaces, 3-15 characters
        return regex.test(code);
    };

    const isValidIndianMobileNumber = (number) => {
        const regex = /^[6-9]\d{9}$/; // Indian mobile number validation
        return regex.test(number);
    };

    const handleSubmit = () => {
        const jsonObject = {
            marketingOptOut: marketingOptOutRows.length > 0
            ? marketingOptOutRows.map((row) => ({
                consentChecked: row.consentChecked,
            }))
            : undefined,

            customQuickReplies: customQuickReplyRows.length > 0
            ? customQuickReplyRows.map((row) => ({
                buttonText: row.buttonText,
            }))
            : undefined,

            visitWebsite: visitWebsiteRows.length > 0
            ? visitWebsiteRows.map((row) => ({
                buttonText: row.buttonText,
                dropdownValue: row.dropdownValue,
                url: row.url,
            }))
            : undefined,
            callPhoneNumbers: callPhoneRows.length > 0
            ? callPhoneRows.map((row) => ({
                mobileNumber: row.mobileNumber,
            }))
            : undefined,

            copyOfferCodes: copyOfferRows.length > 0 
            ? copyOfferRows.map((row) => ({
                offerCode: row.offerCode,
            }))
            : undefined,
        };
    
    
        console.log('Generated JSON Object:', JSON.stringify(jsonObject));
        alert('Form submitted successfully! Check the console for the JSON object.');
    };

    return (
        <WrapperComponent>
            <div className="container mt-4">
            <h2 className="mb-4">Simple Form</h2>
            <div className="dropdown">
                <button
                    className="btn btn-primary dropdown-toggle"
                    type="button"
                    id="addButtonMenu"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    Add Button
                </button>
                <ul className="dropdown-menu" aria-labelledby="addButtonMenu">
                    {/* Section 1: Quick Reply Button */}
                    <li>
                        <h6 className="dropdown-header fw-bold">Quick Reply Button</h6>
                    </li>
                    <li>
                        <label className="dropdown-item">
                            <input
                                type="radio"
                                name="quickReplyOption"
                                value="Marketing opt-out"
                                className="form-check-input me-2"
                                onChange={handleAddMarketingOptOutRow}
                            />
                            Marketing opt-out
                        </label>
                    </li>
                    <li>
                        <label className="dropdown-item">
                            <input
                                type="radio"
                                name="quickReplyOption"
                                value="Custom"
                                className="form-check-input me-2"
                                onChange={handleAddCustomQuickReplyRow}
                            />
                            Custom
                        </label>
                    </li>
                    <li>
                        <hr className="dropdown-divider" />
                    </li>

                    {/* Section 2: Call to Action Button */}
                    <li>
                        <h6 className="dropdown-header fw-bold">Call to Action Button</h6>
                    </li>
                    <li>
                        <label className="dropdown-item">
                            <input
                                type="radio"
                                name="callToActionOption"
                                value="Visit Website"
                                className="form-check-input me-2"
                                onChange={handleAddVisitWebsiteRow}
                            />
                            Visit Website (Max 2 buttons)
                        </label>
                    </li>
                    <li>
                        <label className="dropdown-item">
                            <input
                                type="radio"
                                name="callToActionOption"
                                value="Call Phone Number"
                                className="form-check-input me-2"
                                onChange={handleAddCallPhoneRow}
                            />
                            Call Phone Number (Max 1 button)
                        </label>
                    </li>
                    <li>
                        <label className="dropdown-item">
                            <input
                                type="radio"
                                name="callToActionOption"
                                value="Copy Offer Code"
                                className="form-check-input me-2"
                                onChange={handleAddCopyOfferRow}
                            />
                            Copy Offer Code (Max 1 button)
                        </label>
                    </li>
                </ul>
            </div>
            {/* Dynamically Added Rows */}
            {callPhoneRows.map((row) => (
                    <div key={row.id} className="row mt-3 align-items-center">
                        <div className="col-md-2">
                            <label className="form-label">Call Phone Number</label>
                        </div>
                        <div className="col-md-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Button Text"
                            />
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                className={`form-control ${
                                    row.mobileNumber && !isValidIndianMobileNumber(row.mobileNumber)
                                        ? 'is-invalid'
                                        : ''
                                }`}
                                placeholder="Enter mobile number"
                                value={row.mobileNumber}
                                onChange={(e) => handleMobileNumberChange(row.id, e.target.value)}
                            />
                            {!isValidIndianMobileNumber(row.mobileNumber) && row.mobileNumber && (
                                <div className="invalid-feedback">
                                    Please enter a valid 10-digit Indian mobile number.
                                </div>
                            )}
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-danger"
                                onClick={() => handleRemoveCallPhoneRow(row.id)}
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}
            {/* Dynamically Added Rows for Copy Offer Code */}
            {copyOfferRows.map((row) => (
                    <div key={row.id} className="row mt-3 align-items-center">
                        <div className="col-md-2">
                            <label className="form-label">Copy Offer Code</label>
                        </div>
                        <div className="col-md-2">
                            <input
                                type="text"
                                className="form-control"
                                value="Copy Code"
                                disabled
                            />
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                className={`form-control ${
                                    row.offerCode && !isValidOfferCode(row.offerCode)
                                        ? 'is-invalid'
                                        : ''
                                }`}
                                placeholder="Enter Offer Code"
                                maxLength="15"
                                value={row.offerCode}
                                onChange={(e) => handleOfferCodeChange(row.id, e.target.value)}
                            />
                            {!isValidOfferCode(row.offerCode) && row.offerCode && (
                                <div className="invalid-feedback">
                                    Offer code must be 3-15 characters, contain at least 1 letter and 1 number, and have no spaces.
                                </div>
                            )}
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-danger"
                                onClick={() => handleRemoveCopyOfferRow(row.id)}
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}

                {/* Dynamically Added Rows for Visit Website */}
                {visitWebsiteRows.map((row) => (
                    <div key={row.id} className="row mt-3 align-items-center">
                        <div className="col-md-2">
                            <label className="form-label">Visit Website</label>
                        </div>
                        <div className="col-md-2">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Button Text"
                                value={row.buttonText}
                                onChange={(e) =>
                                    handleVisitWebsiteChange(row.id, 'buttonText', e.target.value)
                                }
                            />
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={row.dropdownValue}
                                onChange={(e) =>
                                    handleVisitWebsiteChange(row.id, 'dropdownValue', e.target.value)
                                }
                            >
                                <option value="Static">Static</option>
                                <option value="Dynamic">Dynamic</option>
                            </select>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                className={`form-control ${
                                    row.url &&
                                    !isValidDomain(row.url, row.dropdownValue)
                                        ? 'is-invalid'
                                        : ''
                                }`}
                                placeholder={
                                    row.dropdownValue === 'Static'
                                        ? 'http://yourdomainname.com'
                                        : 'http://yourdomainname.com/{{1}}'
                                }
                                maxLength="2000"
                                value={row.url}
                                onChange={(e) =>
                                    handleVisitWebsiteChange(row.id, 'url', e.target.value)
                                }
                            />
                            {row.url && !isValidDomain(row.url, row.dropdownValue) && (
                                <div className="invalid-feedback">
                                    Please enter a valid domain name. For dynamic URLs, use parameter values.
                                </div>
                            )}
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-danger"
                                onClick={() => handleRemoveVisitWebsiteRow(row.id)}
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}

                {/* Dynamically Added Rows for Custom */}
            {customQuickReplyRows.map((row) => (
                    <div key={row.id} className="row mt-3 align-items-center">
                        <div className="col-md-2">
                            <label className="form-label">Quick Reply</label>
                        </div>
                        <div className="col-md-6">
                            <input
                                type="text"
                                className={`form-control`}
                                placeholder="Enter Button Text"
                                maxLength="25"
                                value={row.buttonText}
                                onChange={(e) => handleCustomQuickReplyChange(row.id, e.target.value)}
                            />
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-danger"
                                onClick={() => handleRemoveCustomQuickReplyRow(row.id)}
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}
                {/* Dynamically Added Rows for Marketing Opt-Out */}
                {marketingOptOutRows.map((row) => (
                    <div key={row.id} className="row mt-3 align-items-center">
                        <div className="col-md-2">
                            <label className="form-label">Marketing Opt-Out</label>
                        </div>
                        <div className="col-md-6">
                            <input
                                type="text"
                                className="form-control"
                                value="Stop Promotion"
                                disabled
                            />
                            <div className="form-check mt-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`consent-${row.id}`}
                                    checked
                                    onChange={(e) =>
                                        handleConsentChange(row.id, e.target.checked)
                                    }
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`consent-${row.id}`}
                                    style={{ fontSize: '0.9rem' }}
                                >
                                    I understand that it's MSB Doc's responsibility to stop
                                    marketing messages to customers who opt out.
                                </label>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <button
                                className="btn btn-danger"
                                onClick={() => handleRemoveMarketingOptOutRow(row.id)}
                            >
                                Remove
                            </button>
                        </div>
                    </div>
                ))}
            <div className="row mt-4">
                <div className="col-md-12 text-center">
                    <button
                        className="btn btn-success"
                        onClick={() => handleSubmit()}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
        </WrapperComponent>
    );
};

export default SimpleFormComponent;